// SAP Push Detail Key Constants
export const SAP_DETAIL_KEYS = {
    PART_NUMBER: 'PartNumber',
    VENDOR_CODE: 'VendorCode',
    PLANT_CODE: 'PlantCode',
    TAX_CODE: 'TaxCode',
    VALUATION_TYPE: 'ValuationType',
    PO_NUMBER: 'PONumber',
    STORAGE_LOCATION: 'StorageLocation',
    MATERIAL_GROUP: 'MaterialGroup',
    PURCHASING_ORG: 'PurcahasingOrg',
    REASON: 'reason',
    EVALUATION_TYPE: 'EvaluationType',
    CREATION_PROFILE: 'CreationProfile',
    FIRM_ZONE: 'FirmZone',
    TRADE_OFF_ZONE: 'TradeOffZone',
    BINDING_MRP: 'BindingMRP',
    KANBAN_INDICATOR: 'KanbanIndicator',
    INFO_CATEGORY: 'InfoCategory',
    PLANNED_DEL_TIME: 'PlannedDelTime',
    PLANNED_DELAY_TIME: 'PlannedDelayTime',
    COSTING_EXECUTIVE: 'CostingExecutive',
};
